/*
 * The class helps with code completion
 *
 * Defines the interface of objects in the phone number table.
 */

export class BlobPdf {
  constructor(
    public cedola: string,
    public filename: string,
    public data: string,
    public mimeType?: string,
    public creationDate?: Date
  ){}
}

export class BlobImage {
  constructor(
    public url: string,
    public data: Blob,
    public mimeType?: string,
    public tag?: string,
    public width?: string,
    public height?: string,
    public isbn?: string,
    public creationDate?: Date
    /**
     * @todo
     *
     * blobImage deve avere un una proprietà publica isbn, che useremo per le ricerche
     * un campo di tipo data, creationDate serve a refreshare la cache dopo n giorni
     *
     */
  ) {}
}

/*
 * Base 64 Encoded Image.
 * The data property is a string.
 */
export class Base64Image {
  constructor(
    public url: string,
    public data: string,
    public mimeType?: string,
    public tag?: string,
    public width?: string,
    public height?: string
  ) {}
}
